<div class="d-flex flex-column gap-3">
  <ng-container *ngIf="columnAlign === 'center' && isSubstation">
    <lib-equipment-section
      [equipmentInstances]="equipmentInstances"
      [editEnabled]="editEnabled"
      [editableAttributeIds]="equipmentEditableAttributeIds"
      [editedValuesByAsset]="editedEquipmentValues"
      [isAssetRatingEditable]="isAssetRatingEditable"
      [assetRatingOptions]="assetRatingOptions"
      [editedAssetRatings]="editedAssetRatings"
    ></lib-equipment-section>
  </ng-container>
  <ng-container *ngFor="let section of sections; let i = index">
    <ng-container
      *ngIf="
        (columnAlign === 'center' && i % 2 === 0) ||
        (columnAlign === 'right' && i % 2 === 1)
      "
    >
      <lib-section-instance-card
        [section]="section"
        [editEnabled]="editEnabled"
        [editableAttributeIds]="editableAttributeIds"
        [editedValues]="editedValues"
        (mapClicked)="onMapClick($event)"
      ></lib-section-instance-card>
    </ng-container>
  </ng-container>
</div>
